module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue2.5e7609ee.jpg";